const fmt$ = (n) => `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export default function LeadsStatsPanel({ stats }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 border border-zinc-200 mb-6">
      <div className="border-r border-zinc-200 px-6 py-4">
        <div className="label-sm text-zinc-500">Total Leads</div>
        <div className="font-display font-black text-3xl tnum mt-1" data-testid="leads-total">{stats.total_leads}</div>
      </div>
      <div className="border-r border-zinc-200 px-6 py-4">
        <div className="label-sm text-zinc-500">High-Score (80+)</div>
        <div className="font-display font-black text-3xl tnum mt-1 text-emerald-700">{stats.high_score_leads}</div>
      </div>
      <div className="border-r border-zinc-200 px-6 py-4">
        <div className="label-sm text-zinc-500">Avg Score</div>
        <div className="font-display font-black text-3xl tnum mt-1">{stats.avg_health_score}</div>
      </div>
      <div className="px-6 py-4">
        <div className="label-sm text-zinc-500">Avg Revenue</div>
        <div className="font-display font-black text-3xl tnum mt-1">{fmt$(stats.avg_monthly_revenue)}</div>
      </div>
    </div>
  );
}
